function Footer() {
   
    return (
        <div className='footer'>
            <div className="pure-g">
                <div className="pure-u-1 pure-u-lg-1-2">
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%',justifyContent: 'center', gap: '1em' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1em', justifyContent: 'center', alignItems: 'center', gap: '2em' }}>
                            <a href="https://www.facebook.com/people/Dragon-Duck-Games/61564279100314/" target="_blank" rel="noopener noreferrer">
                                <img src="/social_media_logos/facebook.png" alt="Facebook" style={{ width: '2em' }} />
                            </a>
                            <a href="https://bsky.app/profile/dragonduckgames.com" target="_blank" rel="noopener noreferrer">
                                <img src="/social_media_logos/bluesky.png" alt="Twitter" style={{ width: '2em' }} />
                            </a>
                            <a href="https://www.instagram.com/dragonduckgames/" target="_blank" rel="noopener noreferrer">
                                <img src="/social_media_logos/instagram.png" alt="Instagram" style={{ width: '2em' }} />
                            </a>
                            <a href="https://www.youtube.com/@DragonDuckGames" target="_blank" rel="noopener noreferrer">
                                <img src="/social_media_logos/youtube.png" alt="YouTube" style={{ width: '2em' }} />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="pure-u-1 pure-u-lg-1-2" style={{textAlign:'center', fontSize: '0.65em'}}>
                    <p>Copyright © 2026 Dragon Duck Games. All rights reserved.</p>
                </div>

            </div>
        </div>
    );
}

export default Footer;
